import React from "react";
import { Col, Row } from "react-bootstrap";
const Redeembottom = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "px-0" },
                React.createElement(Row, { className: "toc-margin" },
                    React.createElement(Col, { lg: 12, className: "px-3" },
                        React.createElement("div", { className: "marginouter" },
                            React.createElement("div", { className: "leftSection" },
                                React.createElement("span", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "LTCG P&L"),
                                React.createElement("span", { className: "RobotoM_14_500 ps-1" }, "5,059")),
                            React.createElement("div", { className: "rightSection" },
                                React.createElement("span", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "STCG P&L"),
                                React.createElement("span", { className: "RobotoM_14_500 ps-1" }, "37,458")))))))));
};
export default Redeembottom;
